module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-center"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据")]), _vm._v(" "), _c('div', {
    staticClass: "quantity-container"
  }, [_c('div', {
    staticClass: "quantity-detail"
  }, [_c('h2', [_vm._v("指定日预约量")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("指定日预约量（券）：是指用户在购买时已经选择了未来某一天作为使用日期的预约券数量")]), _vm._v(" "), _c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("明天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.tomorrow))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定明天使用的预约券")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("后天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.afterTomorrow))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定后天使用的预约券")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("未来7天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.week))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定未来7天使用的预约券")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("未来30天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.month))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定未来30天使用的预约券")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quantity-whole"
  }, [_c('h2', [_vm._v("有效期预约量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("有效期预约量（券）：在未来的一个有效期内都可以使用的预约券数量")]), _vm._v(" "), _c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("累计")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.dayNumber.total)))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro text-muted"
  }, [_vm._v("未指定使用日期的有效期预约券")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('h2', [_vm._v("历史数据概览及数据趋势")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("历史数据是从过去到昨天的任何一个时间段内的数值，")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('form', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.start,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-item margin-top"
  }, [_vm._v("\n                    ~\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.end,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.getTrend()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.intro))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-type-container"
  }, [_c('div', [_c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'sales' || _vm.filter == 'buyRate'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'sales'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('sales')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("购买量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.sales)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'buyRate'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('buyRate')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("购买率")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("floatToPercent")(_vm.total.buyRate)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'consumption' || _vm.filter == 'consumptionRate'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'consumption'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('consumption')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("验证量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.consumption)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'consumptionRate'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('consumptionRate')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("验证率")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("floatToPercent")(_vm.total.consumptionRate)))])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'refund' || _vm.filter == 'refundRate'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'refund'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('refund')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("退款量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.refund)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'refundRate'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('refundRate')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("退款率")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("floatToPercent")(_vm.total.refundRate)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'pv' || _vm.filter == 'uv'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'pv'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('pv')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("浏览量")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.pv)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'uv'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('uv')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("访客量")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.uv)))])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "showIntro",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_c('a', [_vm._v("点此查看各数据指标定义")])]), _vm._v(" "), (_vm.show) ? _c('ul', {
    staticClass: "list-unstyled intros"
  }, [_c('li', [_vm._v("购买量（券）：旅游券的销售数量（非金额），反映了产品的整体售卖情况")]), _vm._v(" "), _c('li', [_vm._v("访购率：项目的购买人次/访客量，反映了项目的对消费者的吸引力")]), _vm._v(" "), _c('li', [_vm._v("验证量（券）：旅游券的验证数量（非金额），反映了项目的实际接待和收入情况")]), _vm._v(" "), _c('li', [_vm._v("验证率：项目的验证券数量/购买券数量，反映了项目的最终消费情况")]), _vm._v(" "), _c('li', [_vm._v("退款量（券）：旅游券的发生退款的数量（非金额）")]), _vm._v(" "), _c('li', [_vm._v("退款率：项目的退款量（券）/销售量（券）")]), _vm._v(" "), _c('li', [_vm._v("浏览量：项目页面的浏览次数，反映了项目的曝光程度")]), _vm._v(" "), _c('li', [_vm._v("访客量：项目页面的浏览用户数，反映了项目的曝光人数")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "charts",
    attrs: {
      "id": "charts"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("备注：选中相应的数据指标即可查看其数据趋势")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item control-label"
  }, [_c('strong', [_vm._v("选择时间：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd5d6d8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataCenter/operationData.vue
// module id = 616
// module chunks = 0